module.exports = __webpack_public_path__ + "static/media/2_shape_r.52f2ec93.webp";